<template>
	<div class="legal">
		<navbar></navbar>
		<section class="content">
			<md-card>
				<md-card-header>
					<div class="md-title">Adatkezelési nyilatkozat</div>
				</md-card-header>
				<md-card-content>
					Az alkalmazás jelenleg pilot változatban elérhető, és kipróbálható. A folyamatban lévő fejlesztések és véglegesítések miatt a változások jogát fenntartjuk. Hamarosan frissítjük az adatvédelmi irányelveinket, erről mindenkinek értesítés fogunk küldeni. A pilot fázisban kizárólag saját felelősségére ossza meg az adatok a programban. Az egészségügyi adatokat kizárólag a beteg által kiválasztott orvossal osztjuk meg a rendszerünkön keresztül. Az adatokat kutatási célú felhasználásra csak a felhasználó előzetes beleegyezésével tesszük elérhetővé, amit a program felületén engedélyezhet.
				</md-card-content>
			</md-card>
	</br></br>
</section>
</div>
</template>

<script>
	import Navbar from './Navbar'

	export default {
		components: {
			Navbar
		},
		mounted(){
		}
	}
</script>

<style scoped>
	.content{
		margin: 16px;
	}
</style>



// WEBPACK FOOTER //
// LegalView.vue?6391fd53